import React from "react";

import SendIcon from "@uui/Send01";

import HeaderButton from "@app/analytics/components/reports/HeaderButton";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import SendViaMenu from "./SendViaMenu";

const SendVia = () => {
  const anchorElement = useAnchorElement();

  return (
    <>
      <HeaderButton
        aria-controls={anchorElement.open ? "send-via-menu" : undefined}
        aria-haspopup
        aria-expanded={anchorElement.open ? "true" : undefined}
        primary
        startIcon={<SendIcon />}
        onClick={anchorElement.onClick}
      >
        Send via...
      </HeaderButton>
      <SendViaMenu menuProps={anchorElement} />
    </>
  );
};

export default SendVia;
